import { useState } from "react";

import { Module } from "../../types/TenantInterfaces";
import AppPageHeader from "../../components/Headers/AppPageHeader";
import AppEmptyState from "../../elements/AppEmptyState";
import LazyAceEditorComponent from "../../components/QueryBuilder/LazyAceEditorComponent";
import useModifyDynamicModule from "../../api/api-hooks/modules/useModifyDynamicModule";

const QuerySettings = ({ currentModule }: { currentModule: Module }) => {
  const isDynamic = !!currentModule?.Dynamic;
  const [query, setQuery] = useState(currentModule?.SQLQuery ?? "");
  const { modifyDynamicLoading, modifyDynamicModule } =
    useModifyDynamicModule();

  const AppHeader = (
    <>
      <AppPageHeader
        title="Query"
        description="View and edit the SQL query for this data source."
        action={isDynamic ? () => UpdateQuery() : undefined}
        disabled={
          query.replace(/\n/g, " ") === (currentModule?.SQLQuery ?? "") ||
          modifyDynamicLoading
        }
        actionButtonName={isDynamic ? "Save" : undefined}
      />
    </>
  );

  const UpdateQuery = () => {
    let cleanedSQLQuery = query.replace(/\n/g, " ");

    modifyDynamicModule({
      moduleAPIName: currentModule.APIName,
      sqlQuery: cleanedSQLQuery,
    });
  };

  if (!isDynamic) {
    return (
      <>
        {AppHeader}
        <AppEmptyState
          title="Nothing to show"
          description="This module is not a dynamic data source."
          icon="mdi-database-cog-outline"
          hideIcon
        />
      </>
    );
  }

  return (
    <>
      {AppHeader}
      <LazyAceEditorComponent
        width="98%"
        height="300px"
        fontSize={14}
        query={query}
        onChange={(sqlQuery) => {
          setQuery(sqlQuery);
        }}
        className="mx-3"
        id="query-settings"
      />
    </>
  );
};

export default QuerySettings;
